/*
 * File: currentOrderWithPrescriptions.ts
 * Project: meki
 * File Created: Thursday, 15th July 2021 11:49:41 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Wednesday, 19th July 2023 1:10:36 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { Prescription } from '@interfaces';

export const pendingPrescriptions = () => gql`
  query PendingPrescriptions {
    pendingPrescriptions {
      id
      uuid
      url
      createdAt
    }
  }
`;

export type PendingPrescriptionsQueryResponse = {
  pendingPrescriptions?: Prescription[];
};
